import { SelectItem } from 'primeng/api';

export enum ServiceStageValue {
  PendingDelivery = 'PENDING_DELIVERY',
  Writing = 'WRITING',
  Expert = 'EXPERT',
  Intake = 'INTAKE',
  IntakeClient = 'INTAKE_CLIENT',
  Validation = 'VALIDATION',
  Proofreading = 'PROOFREADING',
  Markup = 'MARKUP',
  OnHold = 'ON_HOLD',
  Canceled = 'CANCELED',
  Complete = 'COMPLETE',
  Multiple = 'Multiple',
}

export const SERVICE_STAGE_VALUE = [
  { label: 'Pending Delivery', value: ServiceStageValue.PendingDelivery },
  { label: 'Writing', value: ServiceStageValue.Writing },
  { label: 'Expert', value: ServiceStageValue.Expert },
  { label: 'Intake', value: ServiceStageValue.Intake },
  { label: 'Validation', value: ServiceStageValue.Validation },
  { label: 'Proofreading', value: ServiceStageValue.Proofreading },
  { label: 'Markup', value: ServiceStageValue.Markup },
  { label: 'On Hold', value: ServiceStageValue.OnHold },
  { label: 'Canceled', value: ServiceStageValue.Canceled },
  { label: 'Complete', value: ServiceStageValue.Complete },
  { label: 'Multiple', value: ServiceStageValue.Multiple },
] as SelectItem[];

export interface ServiceStage {
  id: number;
  readableType: string;
  serviceStage: ServiceStageValue;
}

export enum AdditionalServiceStage {
  pending = 'PENDING',
  completed = 'COMPLETED',
  bypassed = 'BYPASSED',
}

export const ADDITIONAL_SERVICE_STAGE_OPTIONS = [
  { label: 'Pending', value: AdditionalServiceStage.pending },
  { label: 'Completed', value: AdditionalServiceStage.completed },
];

export enum TranslationStatus {
  pending = 'PENDING',
  complete = 'COMPLETE',
  canceled = 'CANCELED'
}

export const TRANSLATION_STATUS_OPTIONS = [
  { label: 'Pending', value: TranslationStatus.pending },
  { label: 'Complete', value: TranslationStatus.complete },
  { label: 'CANCELED', value: TranslationStatus.canceled },
];
